import React, { ReactElement } from 'react'
import { spinnerIcon } from '../assets/images/images'

const Spinner = ({ small = false }): ReactElement => {
  return (
    <div
      data-testid="spinner"
      className={`spinner ${small ? 'spinnerSmall' : ''}`}
    >
      <img src={spinnerIcon} alt="Spinner" />
    </div>
  )
}

export default Spinner
